<template>
    <div v-loading="!uploading">
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">
            <el-row v-if="type=='add'">
                <el-col :span="18">
                    <el-form-item label="事件模板" >
                        <el-select v-model="eventTemplateId" @change="getEventTemplate">
                            <el-option v-for="item in eventTemplateList" :key="item.id" :value="item.id" :label="item.title"></el-option>
                        </el-select>
                        <span style="margin-left: 20px;color: #1890ff;">建议使用模板简化您的操作&nbsp;(非必选)</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
            <el-col :span="12">
                <el-form-item label="所属公司" prop="company">
                    <el-select v-model="form.company" placeholder="请选择" filterable>
                        <el-option v-for="item in companyList" :key="item.id" :label="item.name"
                                   :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>
            <el-col :span="12">
                <el-form-item label="请求人" prop="requesterName">
                    <div>
                        <el-input type="text" placeholder="请选择请求人" disabled v-model="form.requesterName" class="form-common mr10"></el-input>
                        <router-link :to="{ path:'/requesterList',query: { enable:true, callback:(val)=>getRequester(val,'requesterName') } }">
                            <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                        </router-link>
                        <el-button  :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                    </div>
                </el-form-item>
            </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="事件分类" prop="category">
                        <el-select v-model="form.category" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="联系方式" prop="contact">
                        <el-input type="text" placeholder="请输入电话号码或者邮箱" v-model="form.contact" class="form-common"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目名称" prop="projectName">
                        <el-select v-model="form.projectName" value-key="id" placeholder="请选择" filterable @change="projectNameEvent">
                            <el-option v-for="item in projectName" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="服务请求" prop="serviceClass">
                        <el-select v-model="form.serviceClass" placeholder="请选择" filterable>
                            <el-option v-for="item in serviceClass" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="项目二线">
                        <div >
                            <el-input type="text" placeholder="请选择项目二线"
                                      disabled v-model="projectUserName" style="margin-right:10px" class="form-common"></el-input>
                            <router-link :to="{ path:'/requesterList',query: {enable:true, callback:(val)=>getRequester(val,'projectUser') } }">
                                <el-button type="primary" class="iconfont icon-gengduo icon"></el-button>
                            </router-link>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="" prop=""></el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="环境" prop="env">
                        <el-select v-model="form.env" filterable placeholder="请选择">
                            <el-option v-for="item in env" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="完成时间"   prop="endTime" class="endTime">
                        <el-date-picker
                            v-model="form.endTime"
                            type="datetime"
                            placeholder="选择日期时间"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            @change="compareTime"
                            style="width: 175px"
                        >
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="事件标题" prop="title">
                        <el-input type="text" placeholder="请输入事件标题"
                                  v-model="form.title"
                                  @change="getKnowledge"
                                  class="form-common"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12" v-if="type == 'edit'">
                    <el-form-item label="编号">
                        <el-input type="text" disabled v-model="form.serialNumber"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="详细描述" prop="description" >
                       <ueditor v-model="form.description" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="事件途径" prop="origin" >
                        <el-select v-model="form.origin" placeholder="请选择"  >
                            <el-option v-for="item in eventOrigin" :key="item.id" :label="item.cname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="紧急度" prop="emergency">
                        <el-select v-model="form.emergency" placeholder="请选择">
                            <el-option v-for="item in emergency" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="优先级" prop="priority">
                        <el-select v-model="form.priority" placeholder="请选择">
                            <el-option v-for="item in priority" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="难易程度" prop="complexity">
                        <el-select v-model="form.complexity" placeholder="请选择">
                            <el-option v-for="item in complexity" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="影响范围" prop="influence">
                        <el-select v-model="form.influence" placeholder="请选择" >
                            <el-option v-for="item in influence" :key="item.id" :label="item.cname"
                                       :value="item.id"

                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="风险等级" prop="risk">
                        <el-select v-model="form.risk" placeholder="请选择" >
                            <el-option v-for="item in risk" :key="item.id" :label="item.cname"
                                       :value="item.id"

                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="关联SLA" prop="toSla">
                        <router-link :to="{ path: '/relevancySla',query:{callback:relevancySla}}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toSla" :getData="getSlaData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="关联问题">
                <router-link :to="{ path: '/relevancyProblem',query:{callback:relevancyProblem}}">
                <el-button type="primary">新增</el-button>
                </router-link>
                <relevancy-tab :data="form.toProblem" :getData="getProblemData"></relevancy-tab>
                </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="关联变更">
                        <router-link :to="{ path: '/relevancyChange',query: { callback:relevancyChange }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toChange" :getData="getChangeData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="关联发布">
                        <router-link :to="{ path: '/relevancyDeploy',query: { callback:relevancyDeploy }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toDeploy" :getData="getDeployData"></relevancy-tab>
                    </el-form-item>
                </el-col>

            </el-row>
            <el-row>
                <el-col :span="6">
                    <el-form-item label="关联事件">
                        <router-link :to="{ path: '/relevancyEvent',query: { callback:relevancyEvent,data:form.toEvent }}">
                            <el-button type="primary">新增</el-button>
                        </router-link>
                        <relevancy-tab :data="form.toEvent" :getData="getEventData"></relevancy-tab>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="关联服务">
                <router-link :to="{ path: '/relevancyService',query:{callback:relevancyService}}">
                <el-button type="primary">新增</el-button>
                </router-link>
                <relevancy-tab :data="form.toService" :getData="getServiceData"></relevancy-tab>
                </el-form-item>
                </el-col>
                <el-col :span="6">
                <el-form-item label="关联配置项">
                <router-link :to="{ path: '/relevancyConfig',query:{callback:relevancyConfig}}">
                <el-button type="primary">新增</el-button>
                </router-link>
                <relevancy-tab :data="form.toCmdb" :getData="getCmdbData"></relevancy-tab>
                </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <new-tag :dadLabel="form.label" :getLabelFromSon="getLabelFromSon"></new-tag>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item v-if="type=='add'">
                <el-button type="primary" size="small" @click="submit('create_commit')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建并提交"}}</el-button>
                <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : "创建"}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
            <el-form-item v-else>
                <el-button type="primary" size="small" @click="submit('create')" :disabled="isSubmit">{{ type == "edit" ? '确定' : ""}}</el-button>
                <el-button type="default" size="small" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./event.service";
    import commonService from "../../services/common.service"
    import knowledge from "../../components/knowledge.vue"
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";

    import ueditor from "../../components/ueditor.vue"
    import relevancyTab from "../common/relevancyTab.vue"
    import newTag from "../common/newTag.vue"
    import inputFile from "../common/inputFile.vue"

    import { getRules } from "./event.rules";
    const rules = getRules();
    export default {
        props:{
            type:{
                type:String,
                default:"add"
            },
            serialNumber:String,
            parentNumber:String,
            parentParams:Object,
            callback:Function
        },
        components:{ knowledge , ueditor , relevancyTab , newTag ,inputFile },
        data() {
            return {
                formName:"form",
                rules:rules,
                form:{
                    company:"",
                    department:"",
                    category:"",
                    contact:"",
                    title:"",
                    description:"",
                    origin:"",
                    emergency:"",
                    priority:"",
                    complexity:"",
                    influence:"",
                    risk:"",
                    label:[],
                    toEvent:[],      // 关联事件
                    toCmdb:[],       // 关联配置项
                    toService:[],    // 关联服务
                    toChange:[],     // 关联变更
                    toDeploy:[],     // 关联发布
                    toProblem:[],    // 关联问题
                    toSla:[],        // 关联SLA
                    slaSn:'',
                    requesterName:"",
                    projectName:'',
                    projectUser:'',//项目二线
                    serviceClass:'',
                    env:'',
                    endTime:''
                },
                projectUserName:'',
                requesterInfo:{},
                defaultUserInfo:{},//新增时默认选取请求人信息
                attachment:[],    // 存放上传的附件
                companyList:[],   // 公司列表
                categoryList:[],  // 事件分类
                isKnowledge:false,
                userTasksTotal:'',   //人员任务数
                isSubmit:false,
                eventTemplateId:null,//新增时选择事件模板
                eventTemplateList:[],
                uploading:true,
                loadingMask:null,  //loading组件
                // busynessUserbtn:true,  控制人员繁忙度的按钮是否可点击
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    // serverUrl: 'http://35.201.165.105:8000/controller.php'/cr/v1/review
                    // serverUrl:Config.baseURL+"upload",
                    // serverUrl:'http://wedof.beta.autoai.com/upload/'
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            // 请求路径
            eventOrigin(){
                return this.dictionary.event_origin;
            },
            // 紧急度
            emergency(){
                return this.dictionary.emergency;
            },
            // 优先级
            priority(){
                return this.dictionary.priority;
            },
            // 难易程度
            complexity(){
                return this.dictionary.complexity;
            },
            // 影响范围
            influence(){
                return this.dictionary.influence;
            },
            //风险等级
            risk(){
                return this.dictionary.event_risk
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            //环境
            env(){
                return this.dictionary.env
            },
            //项目名称
            projectName(){
                return this.dictionary.project_name
            },
            //服务请求
            serviceClass(){
                return this.dictionary.service_class
            },
        },
        created() {
            // console.log(this.dictionary);
            this.getCompanyList();
            this.getCategoryList();
            this.getEventTemplateList()
        },
        mounted(){
            if(this.type!=='edit'&&!this.parentNumber){
                this.getDefaultUser()
            }
            if(this.type == "edit"){
                this.$modal.title = "修改事件";
                setTimeout(()=>{
                    this.getDetail();
                },100)
            }
            if (this.parentNumber) {
                this.$modal.title='提交为事件'
                setTimeout(()=>{
                    this.getDetails()
                },100)
            }
        },
        methods: {
            //改变项目名称
            projectNameEvent(val){
                let data = this.projectName.filter((item,index)=>{
                    return item.id == val
                })
                this.form.projectUser = data[0].user_id
                this.projectUserName = data[0].user_name
            },
            //开始时间和完成时间的对比校验
            CompareDate(d1,d2) {
                //将所有的短横线替换为斜杠
                // return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
                return (d1 > (new Date(d2.replace(/-/g,"\/"))));
            },
            compareTime(){
                const d1 = new Date();
                let d2=this.form.endTime?this.form.endTime:''
                if (this.form.endTime) {
                    let timeCompare=this.CompareDate(d1,d2)
                    if(timeCompare){
                        this.$message.error('完成时间应比当前时间晚，请重新选择')
                        this.form.endTime=''
                    }
                }


            },
            getEventTemplateList(){
                services.getEventTemplateList({type:'event'}).then(res=>{
                    this.eventTemplateList=res
                })
            },
            getEventTemplate(){
                // console.log(this.eventTemplateId);
                services.getEventTemplate(this.eventTemplateId).then(res=>{

                    this.form={
                        ...this.form,
                        ...res.data
                    }
                    //给desscription添加一个后缀用以区分,这个后缀要具备唯一性
                    this.form.description=this.form.description+'模板'
                    this.form.category = this.form.category?+this.form.category:''

                    // this.attachment = res.attachment;
                    //选取模板后，请求人应该还是新增时默认的请求人信息
                    // this.form.requesterName = this.defaultUserInfo.name;
                    // this.requesterInfo.id = this.defaultUserInfo.internalUserid;
                    // this.requesterInfo.name = this.defaultUserInfo.name;
                    // this.requesterInfo.department = this.defaultUserInfo.department;
                    // this.getUserBusyness(this.requesterInfo.id )
                })
            },
            //新增时，报告人/申请人默认选取当前用户
            getDefaultUser(){
                let userId = window.localStorage.getItem('internalUserid')
                let params={
                    internalUserid:userId
                }

                commonService.getUserDetail(params).then(res =>{
                    for (let i in res){
                        this.defaultUserInfo=res[i]
                    }
                    this.form.requesterName = this.defaultUserInfo.name;
                    this.requesterInfo.id = this.defaultUserInfo.internalUserid;
                    this.requesterInfo.name = this.defaultUserInfo.name;
                    this.requesterInfo.department = this.defaultUserInfo.department;
                    this.getUserBusyness(this.requesterInfo.id )
                })

            },

            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },
            // 获取事件分类
            getCategoryList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.categoryList = res;
                })
            },
            // 详情默认显示
            getDetail(){
                services.detail({ serialNumber:this.serialNumber}).then(res => {
                    this.detailSuccessFn(res);
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            detailSuccessFn(res){
                // console.log(res)
                this.form = {...res};
                this.form.category = +this.form.category
                this.attachment = res.attachment;
                let reqId = res.requester ? res.requester.internalUserid : "";
                let reqName = res.requester ? res.requester.name : "";
                let reqDep= res.requester ? res.requester.department : "";
                this.form.requesterName = reqName;
                this.form.projectUser = res.projectUser.userid?res.projectUser.userid:'';
                this.projectUserName = res.projectUser.name?res.projectUser.name:'';
                this.requesterInfo = {
                    id:reqId,
                    name:reqName,
                    department:reqDep
                };
                this.getUserBusyness(this.requesterInfo.id )
            },
            // 提交时详情默认显示
            getDetails(){
               if(this.parentParams){
                   this.form = {
                        ...this.form,
                        ...this.parentParams
                    };
                   let toCmdb=this.parentParams.toCmdb.filter(item => item.serialNumber===this.parentNumber)
                   if (!toCmdb.length){
                       this.form.toCmdb.push({
                           serialNumber:this.parentNumber,
                           title: this.form.title
                       })
                   }
                    this.attachment = this.parentParams.attachment;
               }else{
                   this.getDetailsService();
               }
            },
            getDetailsService(){
                commonService.getCorrectDetail({ serialNumber:this.parentNumber})
                    .then(res => {
                        this.detailSuccessFn(res);

                        //当提交为事件时，只有从事件过来的才有正确的origin和category，其他的都置空
                        let sn=this.parentNumber
                        if(sn.indexOf('Eve')>-1){
                            let origin=res.origin
                            let category=+res.category
                            let risk=res.risk
                            this.form={
                                ...this.form,
                                origin:origin,
                                category:category,
                                toSla:[],
                                risk:risk,
                            }
                        }else{
                            this.form.origin=""
                            this.form.category = "";
                            this.form.risk=""
                            this.form={
                                ...this.form,
                                toSla:[]
                            }
                        }

                    }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            getFiles(val){
                this.attachment = val;
            },
            // 获取编辑器的内容
            // getUeContent(val){
            //     this.form.description = val;
            // },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.form.description = editorInstance.getContent()

                });
            },
            submit(handleStr){
                this.isSubmit=true
                let formName = this.formName;
                this.$refs[formName].validate((valid) => {
                    if(valid){
                        this.isSubmit=true
                        let params = this.getParams();
                        // console.log(params)
                        if(this.type == 'edit'){
                            this.updateEvent(params);
                        }else{
                            params.handle = handleStr
                            this.addEvent(params);
                        }
                    }else{
                        this.isSubmit=false
                        this.$message.error('✳为必填项，请全部填写')

                    };
                    return valid;
                })
            },
            getParams(){
                let form = this.form,
                    toEvent =form.toEvent.map(item => { return item.serialNumber }),
                    toChange = form.toChange.map(item => { return item.serialNumber }),
                    toProblem = form.toProblem.map(item => { return item.serialNumber }),
                    toDeploy = form.toDeploy.map(item => { return item.serialNumber }),
                    toCmdb = form.toCmdb.map(item => { return item.serialNumber }),
                    toService = form.toService.map(item => { return item.serialNumber });


                let params = {
                    ...this.form,
                    // projectUser:projectUser,
                    toEvent:toEvent,
                    toChange:toChange,
                    toProblem:toProblem,
                    toDeploy:toDeploy,
                    toCmdb:toCmdb,
                    toService:toService,
                    slaSn:this.form.toSla[0]?this.form.toSla[0].serialNumber:'',
                    requester:this.requesterInfo.id,
                    attachment:this.attachment,      // 附件
                    department:this.requesterInfo.department.toString(),
                };


                if(this.parentNumber){
                    params.mainCase = this.parentNumber;
                };
                return params;
            },
            getLabelFromSon(val){
                this.form.label=val
            },
            // 创建事件
            addEvent(params){
                services.addEvent(params).then(res => {
                     this.$message.success("事件创建成功");
                     this.close(true);
                 }).catch(err => {
                    this.isSubmit=false
                     this.$message.error(err.message);
                 });
            },
            // 修改事件
            updateEvent(params){
                services.updateEvent(params).then(res => {
                    this.$message.success("事件修改成功");
                    this.close(true);
                }).catch(err => {
                    this.isSubmit=false
                    this.$message.error(err.message);
                })
            },

            // 选择的请求人
            getRequester(obj,str){
                // console.log(obj,'选择请求人[0]');
                if(str == 'projectUser'){
                    this.form.projectUser = obj.internalUserid
                    this.projectUserName = obj.name
                }else{
                    this.requesterInfo = {
                        id:obj.internalUserid,
                        name:obj.name,
                        department:obj.department.id
                    };
                    this.form = {
                        ...this.form,
                        requesterName: obj.name,
                        department:obj.department.id
                    }
                    this.getUserBusyness( this.requesterInfo.id )
                }

            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            //选择完关联项后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.serialNumber]){
                        obj[item.serialNumber]=1
                        newArr.push(item)
                    }
                })
                return newArr
            },

            // 获取选择后的关联的事件
            relevancyEvent(val){
                // console.log(val);
                this.form.toEvent = this.arrayUnique(this.form.toEvent.concat(val))
            },
            // 获取选择后的关联的变更
            relevancyChange(val){
                // console.log(val);
                this.form.toChange = this.arrayUnique(this.form.toChange.concat(val))
            },
            // 获取选择后的关联的发布
            relevancyDeploy(val){
                this.form.toDeploy = this.arrayUnique(this.form.toDeploy.concat(val))
            },
            // 获取选择后的关联的问题
            relevancyProblem(val){
                this.form.toProblem = this.arrayUnique(this.form.toProblem.concat(val))
            },
            //获取选择后的关联的配置项
            relevancyConfig(val){
                this.form.toCmdb = this.arrayUnique(this.form.toCmdb.concat(val))
            },
            //获取选择后的关联的服务
            relevancyService(val){
                this.form.toService = this.arrayUnique(this.form.toService.concat(val))
            },
            relevancySla(val){
                // console.log(val);
                // console.log(this.form.toSla);
                if (this.form.toSla.length==0) {
                    this.form.toSla.push(val)
                }else {
                    this.$message.error('只能关联一个SLA，请删除后再关联新SLA')
                }


            },
            getEventData(val){ this.form.toEvent = val;},
            getCmdbData(val){ this.form.toCmdb = val },
            getServiceData(val){ this.form.toService = val },
            getChangeData(val){ this.form.toChange = val },
            getDeployData(val){ this.form.toDeploy = val },
            getProblemData(val){ this.form.toProblem = val },
            getSlaData(val){ this.form.toSla = val },
            // 标题自动匹配知识库
            getKnowledge(){
                this.isKnowledge = this.form.title ? true : false;
            },
            fileChange(e){
                let files = e.target.files || e.dataTransfer.files;
                if (!files.length){
                    return;
                };
                let params = {
                    file_name:files[0]
                };
                commonService.uploading(params).then(res => {
                    this.attachment.push({
                        name:res.file_name,
                        url:res.download_url,
                        uploadTime:res.upload_time,
                    })
                }).catch( err => {
                    this.$message.error(err.message);
                })
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
